import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import CybersecurityServices from './pages/CybersecurityServices';
import About from './pages/About';
import Contact from './pages/Contact';
import CyberEducation from './pages/CyberEducation';
import CyberEduAdmin from './pages/CyberEduAdmin';
import CoursesAdmin from './pages/CoursesAdmin';
import SoftwareSecurityWebinar from './pages/SoftwareSecurityWebinar';
import Portal from './pages/Portal';

const Layout = () => {
  const location = useLocation();
  const hideNavbarFooter = location.pathname === '/cyber-edu-admin';

  return (
    <div className="App">
      {!hideNavbarFooter && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cybersecurity-services" element={<CybersecurityServices />} />
        <Route path="/cyber-education" element={<CyberEducation />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cyber-edu-admin" element={<CyberEduAdmin />} />
        <Route path="/cyber-edu-admin/courses" element={<CoursesAdmin />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/software-security-testing" element={<SoftwareSecurityWebinar />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!hideNavbarFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;